import { needsQuickReview } from '@dc1/shared';
import { createFileRoute, redirect } from '@tanstack/react-router';
import { meQuery, resultsQuery, whatsNewQuery } from '../../api/queries';

/**
 * Home. First-timers see the guide. At the start of a period: "what's new" until seen, then the quick
 * review while levels carried over from the last period are not reviewed yet. Otherwise the results.
 */
export const Route = createFileRoute('/_app/')({
  beforeLoad: async ({ context }) => {
    const profile = await context.queryClient.query({ ...resultsQuery, staleTime: 'static' });
    if (!profile.areas.some((a) => a.selfLevel !== null || a.isNa)) throw redirect({ to: '/intro' });
    const me = await context.queryClient.query({ ...meQuery, staleTime: 'static' });
    if (me.openPeriod) {
      const whatsNew = await context.queryClient.query(whatsNewQuery);
      if (whatsNew.pending) throw redirect({ to: '/whats-new' });
      if (needsQuickReview(profile.areas, new Set(profile.reviewedAreaIds)))
        throw redirect({ to: '/review' });
    }
    throw redirect({ to: '/results' });
  },
});
